<template>
  <div ref="ysplayer" :class="[className, 'w-full', 'h-full']"></div>
</template>

<script>
/* 宇视——视频播放器 */

import { IOTDeviceProtocolInstanceApi } from '@wiz-api/iot-device-management'

const iotDeviceProtocolInstanceApi = new IOTDeviceProtocolInstanceApi()
export default {
  props: {
    // 摄像头编码
    code: {
      type: String,
      defalut: '',
    },
    // 获取协议实例需要用到【pIid】,返回的内容包含有ip、端口、用户名、密码
    pIid: {
      type: String,
      defalut: '',
    },
  },
  data() {
    return {
      className: `ys-${_.random(0, 99999)}-player`,
      streamType: 2, // 码流类型; 1 = 主码流；2 = 辅码流
      iframeObjId: '',
      ipAddress: '',
      username: '',
      password: '',
      port: '',
    }
  },
  async mounted() {
    const _this = this
    window.addEventListener('resize', (e) => {
      if (e.keyCode === 27 && _this.streamType === 1) {
        _this.streamType = 2
        _this.playLive()
      }
    })
    await this.getConfig()
  },
  methods: {
    // 登录
    async login() {
      const _this = this
      const apiUrl = `http://${this.ipAddress}:${this.port}/VIID/login/v2`
      const requestOption = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
      }
      fetch(apiUrl, requestOption)
        .then((response) => {
          if (response.status === 200) {
            return response.json()
          }
          throw new Error('网络请求失败')
        })
        .then((res) => {
          const accessCode = res.AccessCode
          const md2 = forge.md.md5.create() // md5
          const base64Username = window.btoa(this.username)
          const loginSignatureTemp = base64Username + accessCode + this.password
          md2.update(loginSignatureTemp) // md5
          const loginSignature = md2.digest().toHex() // md5
          const data = {
            UserName: this.username,
            AccessCode: accessCode,
            LoginSignature: loginSignature,
          }
          const requestOpion2 = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json; charset=utf8',
            },
            body: JSON.stringify(data),
          }
          fetch(apiUrl, requestOpion2)
            .then((response) => {
              if (response.status === 200) {
                return response.json()
              }
              throw new Error('网络请求失败')
            })
            .then((r) => {
              const loginResult = r.ErrCode
              switch (
                loginResult // 判断返回值：12351是‘用户不存在’；50004是‘密码错误，登录失败’
              ) {
                case 50004:
                  break
                case 12351:
                  break
                case undefined:
                  window.playerToken = r.AccessToken
                  // 在使用https 的时候设置为https 代理端口号
                  const ishttps = document.location.protocol === 'https:'
                  if (ishttps) {
                    imosSdk.setLinkPort('7077')
                  }
                  const vmip = _this.ipAddress
                  imosSdk
                    .init(vmip, window.playerToken, 1, '/unv/imosSdk.html') // 1 代表最多允许同时播放窗格数
                    .then(() => {
                      // 设置后续事件回调
                      imosSdk.registerLiveMsg((result) => {
                        if (result.Type === 'zoom' && result.Zoom === 1) {
                          // 全屏 需要切换到主码流
                          _this.streamType = 1
                          _this.playLive()
                        }
                        if (result.Type === 'zoom' && result.Zoom === 0) {
                          // 缩小 需要切换到辅码流
                          _this.streamType = 2
                          _this.playLive()
                        }
                      })
                    })
                    .catch((err) => {})
                  break
                default:
              }
              _this.creatWindow()
            })
            .catch((e) => {})
        })
        .catch((error) => {})
    },
    async getConfig() {
      const [err, res] = await iotDeviceProtocolInstanceApi.get(this.pIid)
      if (!err) {
        const parsedInfo = JSON.parse(res.jsonContent)
        // const parsedInfo = JSON.parse(
        //   '{"UserName":"loadmin","PassWord":"2c57282991e301c1c542f67396fed9d5","IP":"imos.wiz.top","Port":"80"}'
        // ) // 模拟
        this.ipAddress = parsedInfo.IP
        this.username = parsedInfo.UserName
        this.password = parsedInfo.PassWord
        this.port = parsedInfo.Port
        this.login()
      } else {
        this.ipAddress = ''
        this.username = ''
        this.password = ''
        this.port = ''
      }
    },
    // 创建窗格
    creatWindow() {
      if (!window.playerToken) {
        return
      }
      const iframeObj = imosSdk.createPanelWindow()
      // 如果窗格创建已经到达上限
      if (iframeObj === null) {
        return
      }
      this.iframeObjId = iframeObj && iframeObj.id
      this.createSpeDiv(iframeObj)
    },
    createSpeDiv(iframeObj) {
      const videoDom = this.$refs.ysplayer
      // 如果存在子节点那么清除重新创建
      if (videoDom.hasChildNodes()) {
        videoDom.innerHTML = null
      }
      let divDom = document.createElement('div')
      divDom.style = 'height: 100%;'
      divDom.appendChild(iframeObj)
      videoDom.appendChild(divDom)
      divDom = null
      this.playLive()
    },
    // 实时播放
    playLive() {
      if (!window.playerToken || !this.code) {
        return
      }
      imosSdk.playLive(
        this.iframeObjId, // 播放窗格的Id
        this.code, // 摄像头编码
        this.code, // 需要显示的标题名称
        (e) => {},
        this.streamType
      )
    },
  },
  watch: {
    code() {
      this.creatWindow()
    },
  },
}
</script>

<style scope lang="scss">
.imosSdk-video {
  height: 100% !important;
  width: 100% !important;
  box-sizing: border-box;
}
</style>
